import React from "react";
import data from "./data";
import Project from "./Project";

export default function Projects() {

    let projectcard = data.map(item => {
        return (
          <Project
            {...item}
          />
        )
      })

    return (
        <div className="section">
        <div className="projects-title" id="projects">
            <h2><span class="material-symbols-outlined bullet2">square</span>Projects </h2>
            <p>Check out some of my projects down below!</p>
            {projectcard}

            </div>

        </div>
        
    )
}